<template>
    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
        <h2 class="my-text-black" style="text-align: center;">Seleccione el paciente al que quiere auditar.</h2>
        <v-autocomplete
            v-model="paciente"
            variant="solo"
            :items="opcionesPaciente"
            :item-title="pacienteTitle"
            return-object
            :rules="obligatorio"
            :loading="cargando"
            label="Paciente - Documento"
            required
            class="asterisco"
            @update:model-value="cambiarPaciente"
        >
        </v-autocomplete>
        <v-btn type="submit" block id="boton-verde" :disabled="!valid || cargando" :loading="cargando">Seleccionar</v-btn>
    </v-form>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert= false"
    />
</template>

<style src="../assets/base.css"></style>

<script>
import PacienteService from '@/api/PacienteService';
import AlertComponent from '@/components/AlertComponent';
import { obligatorio } from '@/_helpers/rules';

const pacienteService = new PacienteService();

export default {
    components: {
        AlertComponent
    },
    data() {
        return {
            paciente: null,
            opcionesPaciente: [],
            cargando: false,
            obligatorio: obligatorio,
            valid: false,
            //datos para mostrar errores
            showAlert:false,
            alertTitle: '',
            alertText: '',
            alertType: '',
        }
    },
    async mounted(){
        await this.getPacientes();
    },
    methods: {
        async handleSubmit(){
            if(this.paciente){
                this.$router.push('/auditoria-reintegros/listado-reintegros-auditor');
            }
        },
        async getPacientes(){
            this.cargando = true;
            const response = await pacienteService.getPacientesConReintegros();
            if(response.status === 200){
                this.opcionesPaciente = response.data;
                this.cargando = false;
            }
            else{
                this.alertTitle = 'Error al cargar pacientes';
                this.alertText = 'No se pudieron cargar los pacientes.';
                this.alertType = 'error';
                this.showAlert = true;
            }
        },
        pacienteTitle(item){
            if (!item) return '';
            return `${item.apellidoNombre} - ${item.numeroDocumento}`;
        },
        cambiarPaciente(){
            this.cargando = true;
            if(this.paciente){
                this.$store.commit('setPaciente', this.paciente);
            }
            this.cargando = false;
        }
    }
}
</script>